module.exports = __webpack_public_path__ + "static/img/6449_phase_function_Paper_PointsHejduk_Prediction.2b41d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6449_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EwRY
// module chunks = 0